import script from "./ResourceViewComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ResourceViewComponent.vue?vue&type=script&setup=true&lang=js"

import "./ResourceViewComponent.vue?vue&type=style&index=0&id=27bceddc&lang=css"

const __exports__ = script;

export default __exports__